import * as Yup from 'yup';
import { isDefined, isEmptyString } from 'lib/typeguards';

const isSet = (value?: string) => isDefined(value) && !isEmptyString(value);

const DOMAIN_REGEX = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/i;

// A bare domain name has no scheme, so `new URL(value)` throws. If it parses
// successfully, the user included a scheme (http://, https://, etc.), which we reject.
const hasUrlScheme = (value?: string): boolean => {
    if (!isSet(value)) {
        return false;
    }
    try {
        // eslint-disable-next-line no-new
        new URL(value);
        return true;
    } catch {
        return false;
    }
};

export const domainNameSchema = () =>
    Yup.string()
        .trim()
        .test('no-scheme', 'Enter a domain only, without http:// or https://.', value => !hasUrlScheme(value))
        .matches(DOMAIN_REGEX, 'Enter a valid domain, e.g. app.pepperhq.com.');
